import React from 'react'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css'
// import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import { Grid, Box, Typography } from '@material-ui/core'
import Image from '../../../shared/Image'
import rossieDeering from '../../../assets/images/photos/people/rosie_deering.jpeg'
import hannahSmith from '../../../assets/images/photos/people/hannah_smith.jpeg'

SwiperCore.use([Navigation])
const useStyles = makeStyles((theme) => ({
  testiMonialContainer: {
    maxWidth: 1140,
    margin: '0 auto',
    height: '100%',
    position: 'relative',
    [theme.breakpoints.down('1450')]: {
      maxWidth: 1040,
    },
    [theme.breakpoints.down('1299')]: {
      maxWidth: 850,
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: 748,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(100% - 130px)',
    },
    [theme.breakpoints.down('690')]: {
      maxWidth: '100%',
      padding: '0 15px',
    },
    '& .swiper-button-prev': {
      left: '-20%',
      transform: 'translateY(-50%)',
      color: '#000',

      [theme.breakpoints.down('1600')]: {
        left: '-10%',
      },
      [theme.breakpoints.down('1450')]: {
        top: '40%',
        left: '-13%',
      },
      [theme.breakpoints.down('sm')]: {
        left: '-6%',
      },
      [theme.breakpoints.down('690')]: {
        left: '2%',
      },
      '&::after': {
        [theme.breakpoints.down('xs')]: {
          fontSize: 30,
        },
      },
    },
    '& .swiper-button-next': {
      right: '-20%',
      transform: 'translateY(-50%)',
      color: '#000',

      [theme.breakpoints.down('1600')]: {
        right: '-10%',
      },
      [theme.breakpoints.down('1450')]: {
        top: '40%',
        right: '-13%',
      },
      [theme.breakpoints.down('sm')]: {
        right: '-6%',
      },
      [theme.breakpoints.down('690')]: {
        right: '2%',
      },

      '&::after': {
        [theme.breakpoints.down('xs')]: {
          fontSize: 30,
        },
      },
    },
  },
  testimonialContent: {
    '& h3': {
      fontSize: 32,
      fontWeight: 600,
      color: '#212121',
      lineHeight: '45px',
      marginBottom: '50px',
      [theme.breakpoints.down('sm')]: {
        fontSize: 26,
        lineHeight: '36px',
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 22,
        lineHeight: '30px',
      },
    },
    '& h6': {
      fontSize: 18,
      fontWeight: 800,
      color: theme.palette.common.black,
      marginBottom: 0,
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
    },
    '& p': {
      fontSize: 18,
      fontWeight: 400,
      color: theme.palette.common.black,
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
    },
    '& img': {
      width: 100,
      height: 100,
      objectFit: 'cover',
      borderRadius: '100%',
      marginRight: 20,
      [theme.breakpoints.down('xs')]: {
        marginRight: 0,
      },
    },
  },
  clientImageBox: {
    [theme.breakpoints.down('690')]: {
      width: '100%',
      textAlign: 'center',
    },
  },
  clientTextBox: {
    [theme.breakpoints.down('690')]: {
      width: '100%',
      textAlign: 'center',
      position: 'relative ',
      padding: '0 50px',
    },
  },
  webNav: {
    [theme.breakpoints.down('690')]: {
      display: 'none',
    },
  },
  nameCom: {
    fontWeight: '600 !important',
  },
  mobileNav: {
    display: 'none',
    [theme.breakpoints.down('690')]: {
      display: 'block',
    },
  },
}))

const testimonialContent = [
  {
    content:
      'Conduiit’s intuitive platform has been imperative to keeping myself and my team organized and on track with accounting. We would not have been able to process invoices, cost reports, etc. at the same level of efficiency without it.',
    clientImage: rossieDeering,
    clienName: 'Rosie Deering',
    designation: 'Production Manager, Oligarchs',
    location: 'HBO',
  },
  {
    content:
      'I have been using Conduiit for about four years at a documentary production company. It has greatly improved workflow and communication between production and our accounting department. Conduiit streamlines the PO process in eliminating paper POs, which is ideal.',
    clientImage: hannahSmith,
    clienName: 'Hannah Smith',
    designation: 'Production Supervisor, How To Change Your Mind',
    location: 'Netflix',
  },
]

const Reviews = () => {
  // const { data, className } = props
  const classes = useStyles()

  return (
    <>
      <div className={classes.testiMonialContainer}>
        <Swiper
          spaceBetween={0}
          loop
          speed={800}
          navigation={{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          }}
          className={classes.mySwiper}
        >
          {testimonialContent.map((item, index) => (
            <SwiperSlide key={index}>
              <Box className={classes.testimonialContent}>
                <Typography variant="h3">{item.content}</Typography>
                <Grid container alignItems="center">
                  <Grid item className={classes.clientImageBox}>
                    <Box>
                      <Image src={item.clientImage} alt="" />
                    </Box>
                  </Grid>
                  <Grid item className={classes.clientTextBox}>
                    <Box>
                      <Typography variant="h6">{item.clienName} </Typography>
                      <Typography variant="body1">
                        {item.designation}
                      </Typography>
                      <Typography variant="body1" className={classes.nameCom}>
                        {item.location}
                      </Typography>
                      <div className={classes.mobileNav}>
                        <div className="swiper-button-next"></div>
                        <div className="swiper-button-prev"></div>
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className={classes.webNav}>
          <div className="swiper-button-prev"></div>
          <div className="swiper-button-next"></div>
        </div>
      </div>
      {/* <SectionHeader
        title="Our customers are our biggest fans."
        subtitle="We dont' like to brag, but we don't mind letting our customers do it for us. Here are a few nice things folks have said about our themes over the years."
        align="center"
        data-aos="fade-up"
      />
      <Grid container spacing={isMd ? 4 : 2}>
        {data.map((item) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={uid()}
            className={classes.gridItem}
            data-aos="fade-up"
          >
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <ListItem disableGutters key={uid()}>
                  <ListItemAvatar className={classes.listItemAvatar}>
                    <Avatar {...item.authorPhoto} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={item.authorName}
                    secondary={item.authorOccupation}
                    primaryTypographyProps={{
                      variant: 'h6',
                    }}
                    secondaryTypographyProps={{
                      variant: 'body1',
                      noWrap: true,
                    }}
                  />
                </ListItem>
              </Grid>
              <Grid item xs={12}>
                <CustomTypography variant="subtitle1">
                  {item.feedback}
                </CustomTypography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid> */}
    </>
  )
}

// Reviews.propTypes = {
//   // className: PropTypes.string,
//   // data: PropTypes.array.isRequired,
// }

export default Reviews
